import React, { Fragment } from 'react';

import Button from '@material-ui/core/Button';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import CONFIG from '../cfg/config';

import { payService, payStatus, bookService, ReservationId, Rezerwacja, payServicePrzelewy24, Przelewy24Status, vscPaymentPrzelewy24 } from '../api';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';
import { WithStyles } from '@material-ui/styles';
import { AppState, IPageState, store, Actions } from '../appredux';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import { downloadQRReserv, sendErrorLog, selectTheme } from './common/helpers';
import { Link } from '@material-ui/core';

export type Content = {
  message: string,
  messageBoldPrimary?: string,
  redValue?: boolean,
  icon?: any
}

export class NotifierData {
  paymentId: string = '';
  reservationId: number = 0;
  dialogContent: Content[] = [];
  dialogContentFailure: Content[] = [];
  reservation: Rezerwacja = new Rezerwacja();
  success: boolean = false;
  handleClose: () => Promise<void> = () => { return new Promise(resolve => resolve()) };
  roomDescription: string = '';

  constructor(data?: any) {
    if (data) {
      this.paymentId = data.paymentId;
      this.reservationId = data.reservationId;
      this.dialogContent = data.dialogContent;
      this.dialogContentFailure = data.dialogContentFailure;
      this.reservation = data.reservation;
      this.success = data.success;
      this.handleClose = data.handleClose;
      this.roomDescription = data.roomDescription;
    }
  }
}

type ModalProps = {
  messagePart1?: string,
  messagePart2?: string,
  title?: string,
  titleFailure?: string,
  success?: boolean,
  yellow?: boolean,
  reservation?: Rezerwacja,
  dialogContent: Content[],
  dialogContentFailure: Content[],
  handleClose?: () => void,
  paymentId?: string,
  reservationId?: number,
  paymentLink?: string,
  czyPlatnosc?: boolean,
  page: IPageState,
  mode?: number,
  cancellReservation?: (id: number) => void,
  roomDescription?: string
}

type NotifierState = {
  open: boolean,
  width: number,
  //interval: any,
  status: string,
  lastStatus: string,
  openConfirm: boolean,
  reminderInterval: boolean,
  timeMinutes: number,
  timeStart: number,
  //count: number
}

const wciecie: string = '  * ';

class Notifier extends React.Component<WithTranslation & ModalProps & TransProps & WithStyles<typeof styles>, NotifierState> {
  state = {
    open: true,
    //count: 0,
    width: window.innerWidth,
    //interval: null,
    openConfirm: false,
    reminderInterval: true,
    status: (this.props.paymentId && this.props.paymentId != "") ? 
      'PreStart' : '2',
    lastStatus: (this.props.paymentId && this.props.paymentId != "") ?
      'PreStart' : '2',
    timeMinutes: 1,
    timeStart: new Date().getTime()
  };

  interval: any;
  logInterval: any;
  timeout: any;

  handleModalClose = () => {
    this.setState({
      open: false,
      //count: this.state.count + 1
    });

    if (this.props.handleClose)
      this.props.handleClose();

    //clearInterval(this.interval);
    //clearTimeout(this.timeout);

    //if (this.state.status != "PositiveFinish") {
    //  this.sendFailure();
    //}

  };

  openManageReservation = () => {
    this.handleModalClose()
    store.dispatch(Actions.pageState.setOpenRezerwacjaZarzadzaj({tel: this.props.reservation!.gosc_telefon, nr: this.props.reservationId}))  
  }

  openModal = (message: string, title: string) => {
    this.setState({ open: true });
  };

  openConfirm = () => {
    this.setState({ openConfirm: true });
  };

  closeConfirm = () => {
    this.setState({ openConfirm: false });
  };

  cancellReservation = () => {
    this.setState({
      open: false,
      openConfirm: false
    });

    if (this.props.cancellReservation)
      this.props.cancellReservation(this.props.reservationId!);
  }

  // componentWillReceiveProps() {
  //   this.setState({
  //     open: true
  //   });
  // };

  componentDidMount() {
    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
    if (this.props.paymentId && this.props.paymentId != "") {
      this.setPaymentInterval()
    }
  }

  // shouldComponentUpdate(nextProps: ModalProps, nextState: NotifierState){
  //   if(this.state.width == nextState.width)
  //     return true;
  //   if(this.state.width < 600 && nextState.width > 600 || this.state.width > 600 && nextState.width < 600){
  //     return true
  //   } else {
  //     return false
  //   } 
  // }

  componentDidUpdate(prevProps: ModalProps, prevState: NotifierState) {
    // if(prevState.width !== this.state.width) {
    //   return 
    // }
    //if(!this.state.open && prevState.count == this.state.count )
    //  this.setState({ ...this.state, open: true });

    if (this.props.page.notifierOpen !== prevProps.page.notifierOpen){
      this.setState({ ...this.state, open: true, reminderInterval: true, 
        status: (this.props.paymentId && this.props.paymentId != "") ? 'PreStart' : '2'  });
    }
    if (prevProps.paymentId !== this.props.paymentId && this.props.paymentId && this.props.paymentId != "") {
      clearInterval(this.interval);
      clearInterval(this.logInterval);
      clearTimeout(this.timeout);
      this.setPaymentInterval();
      this.setState({ ...this.state, status: 'PreStart' });
    }

    if (prevProps.dialogContentFailure.length !== this.props.dialogContentFailure.length
      || prevProps.success !== this.props.success
      || prevProps.reservationId !== this.props.reservationId)
      this.setState({ ...this.state, open: true });
  }

  timeDifference = () : string => {
    let date = new Date(new Date().getTime() - this.state.timeStart) ;
    let min = date.getUTCMinutes();
    let sec = date.getUTCSeconds();
    let ss = sec <= 9 && sec >= 0 ? `0${sec}` : sec;
    let mm = min <= 9 && min >= 0 ? `0${min}` : min;
    return mm + ":" + ss;
  }

  setPaymentInterval = () => {
    this.interval = setInterval(() => {
      this.paymentState(this.props.paymentId!);
    }, 10000); // 10s
    this.logInterval = setInterval(() => {
      this.logCount();
    }, 60000); // 60s

    //brak anulacji
    // this.timeout = setTimeout(() => {
    //   //if(this.state.isFailure){
    //     sendErrorLog("1", "1", "minelo 15min od rozpoczecia transakcji, anulacja")
    //     store.dispatch(Actions.pageState.addFcmLogMessage("minelo 15min od rozpoczecia transakcji, anulacja", 0))    
    //     this.sendFailure();
    //     this.setState({ ...this.state, status: 'NegativeFinish' });
    //   //}  
    //   clearInterval(this.interval);
    //   clearInterval(this.logInterval);
    // }, 900000); //15 min
  }

  setReminderInterval = () => {
    this.interval = setInterval(() => {
      this.paymentState(this.props.paymentId!);
    }, 5000);
    this.timeout = setTimeout(() => {
      //if(this.state.isFailure){
         //????????????????????????????????????????????????????
         this.sendSuccess();
         this.setState({ status: '2'})
         sendErrorLog("0", "-1", `platnosc stan 1, powinien być 2 poczatek ${CONFIG.hotelID +":"+ this.props.paymentId!}, czas: ${this.timeDifference()}`)
         store.dispatch(Actions.pageState.addFcmLogMessage(`platnosc stan 1, powinien być 2 poczatek ${CONFIG.hotelID +":"+ this.props.paymentId!}, czas: ${this.timeDifference()}`, 2))
      //}  
      clearInterval(this.interval);
      clearInterval(this.logInterval);
    }, 30000); //30 s
  }

  updateWindowWidth = () => {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  logCount = () => {
    sendErrorLog("1", "1", `minelo ${this.state.timeMinutes}min od rozpoczecia transakcji`)
    store.dispatch(Actions.pageState.addFcmLogMessage(`minelo ${this.state.timeMinutes}min od rozpoczecia transakcji`, 0))   
    this.setState({timeMinutes: this.state.timeMinutes + 1}) 
  }

  async paymentState(id: string) {
    //console.log("status")
    try {


      switch (this.props.page.contact.payWeb) {
        case "2": //CashBill

          let res1: payStatus = await payService.getStatus({ hotelId: CONFIG.hotelID, idPlatnosci: id })
          //console.log(res)            
          await this.setState({ status: res1.status })

          if(this.state.status !== this.state.lastStatus){
            this.setState({ lastStatus: res1.status })
            sendErrorLog("1", "1", `status platnosci: ${res1.status}, czas: ${this.timeDifference()}`)
            store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: ${res1.status}, czas: ${this.timeDifference()}`, 0))
          }

          if (res1.status == "2") {
            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
            this.sendSuccess();
          } else if (res1.status !== 'PreStart' &&
            res1.status !== '0' &&
            res1.status !== 'PositiveAuthorization' &&
            res1.status !== '2') {
            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
            this.sendFailure();
            }

          break;
        case "1": //Przelewy24
        //if(CONFIG.preautoryzacja === '0'){  // przelew bankowy
        if(this.props.page.preautoryzacja === 0){  // przelew bankowy

          let res2: Przelewy24Status = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelID, vscNr: Number(id), prefiks: CONFIG.payWebPrefiks, kontoId: CONFIG.payWebKontoId, })
          //console.log(res2)
          if (res2 && res2.data.status === 0) {
            this.setState({ status: '0' })   
            
            if(this.state.status !== this.state.lastStatus){
              this.setState({ lastStatus: '0' })
              sendErrorLog("1", "1", `status platnosci: 0, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 0, czas: ${this.timeDifference()}`, 0))
            }

          }else if (res2 && res2.data.status === 1) {
            this.setState({ status: '1' }) 

            if(this.state.lastStatus !== '1' ){
              this.setState({ lastStatus: '1' })
              sendErrorLog("1", "1", `status platnosci: 1, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 1, czas: ${this.timeDifference()}`, 0))
            }

            
            //this.setState({ status: '2' })
            //////////////////////////////////////////////////////////// brak przejścia z 1 na 2, bo w mBanku status 1 oznacza wybór metody płatności
            // if(this.state.reminderInterval){
            //   this.sendConfirmation(res2)
            //   clearInterval(this.interval);
            //   clearInterval(this.logInterval);
            //   clearTimeout(this.timeout);
            //   this.setReminderInterval()
            //   this.setState({ reminderInterval: false})
            // }
            ////////////////////////////////////////////////////////////
            //this.sendSuccess();
          } else if(res2 && res2.data.status === 2){
            this.setState({ status: '2'})//, isFailure: false })

            if(this.state.lastStatus !== '2'){
              this.setState({ lastStatus: '2' })
              sendErrorLog("1", "1", `status platnosci: 2, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 2, czas: ${this.timeDifference()}`, 0))
            }

            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
            

            const pobyt = await bookService.reservGet
            ({
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aPobytId: this.props.reservationId!,
                aDomena: this.props.page.lang,
            }, {});

            if(pobyt && pobyt.result[0] &&pobyt.result[0].status_id === 2){
              this.sendSuccess();
            }

            
            
            //this.sendSuccess();
          }
          // let res2: payStatusPrzelewy24 = await payServicePrzelewy24.getStatus({ hotelId: CONFIG.hotelID, vscNr: id })
          // console.log(res2)
          // if (res2.akcjaStatus === "0" && res2.akcjaWynik === "0") {  // transakcja oczekuje na potwierdzenie
          //   this.setState({ status: 'Waiting', isFailure: false })
          //   //clearInterval(this.interval);
          //   //this.sendSuccess();
          // } else if (res2.akcjaStatus === "1" && res2.akcjaWynik === "1") {  // koniec sukces
          //   this.setState({ status: '2' })
          //   clearInterval(this.interval);
          //   this.sendSuccess();
          // } 

        //} else if(CONFIG.preautoryzacja === '1') {  // płatność kartą, preautoryzacja
        } else if(this.props.page.preautoryzacja === 1) {  // płatność kartą, preautoryzacja

          let res3: Przelewy24Status = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelID, vscNr: Number(id), prefiks: CONFIG.payWebPrefiks, kontoId: CONFIG.payWebKontoId, })
          //console.log(res3)
          if (res3 && res3.data.status === 0) {
            this.setState({ status: '0' })  
            
            if(this.state.status !== this.state.lastStatus){
              this.setState({ lastStatus: '0' })
              sendErrorLog("1", "1", `status platnosci: 0, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 0}, czas: ${this.timeDifference()}`, 0))
            }

          }else if (res3 && res3.data.status === 1) {

            if(this.state.lastStatus !== '1'){
              this.setState({ lastStatus: '1' })
              sendErrorLog("1", "1", `status platnosci: 1, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 1}, czas: ${this.timeDifference()}`, 0))
            }
            //this.sendConfirmation(res3)
            this.sendSuccess();
            this.setState({ status: '2'})//, isFailure: false })
            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
          } else if (res3 && res3.data.status === 2) {

            if(this.state.lastStatus !== '2'){
              this.setState({ lastStatus: '2' })
              sendErrorLog("1", "1", `status platnosci: 2, czas: ${this.timeDifference()}`)
              store.dispatch(Actions.pageState.addFcmLogMessage(`status platnosci: 2, czas: ${this.timeDifference()}`, 0))
            }
            //this.sendConfirmation(res3)
            this.sendSuccess();
            this.setState({ status: '2'})//, isFailure: false })
            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
            await sendErrorLog("0", "-1", `preautoryzacja stan 2 poczatek ${res3.data.sessionId}, czas: ${this.timeDifference()}`)
            await store.dispatch(Actions.pageState.addFcmLogMessage(`preautoryzacja stan 2 poczatek ${res3.data.sessionId}, czas: ${this.timeDifference()}`, 2))
          }
        } 

          break;
        //case "5": //TPay

        //  break;

        default:
          break;
      }

    } catch (error) {
      await sendErrorLog("0", "-1", 'pobranie stanu platnosci')
      await store.dispatch(Actions.pageState.addFcmLogMessage("pobranie stanu platnosci", 2))
      console.log(error)
    }
  }

  async sendConfirmation(status: Przelewy24Status) {
    try {
      let res: vscPaymentPrzelewy24 = await payServicePrzelewy24.getConfirmation(
        {
          hotelId: CONFIG.hotelID,
          vscKwota: status.data.amount,
          vscId: this.props.reservationId!,
          anuluj: 0 // 0- sukces  1- porażka
 
        }, {})
      //console.log(res) 
      sendErrorLog("1", "1", `przelewy24/potwierdzenie, czas: ${this.timeDifference()}`)
      store.dispatch(Actions.pageState.addFcmLogMessage(`przelewy24/potwierdzenie, czas: ${this.timeDifference()}`, 2)) 
    } catch (error) {
       await sendErrorLog("0", "-1", '/vscPay/przelewy24/potwierdzenie')
       await store.dispatch(Actions.pageState.addFcmLogMessage("/vscPay/przelewy24/potwierdzenie", 0))
      console.log(error);
    }
  }

  async sendSuccess() {
    if (CONFIG.payWebPotwierdzAktywny === "1") {

      try {
        let res: ReservationId = await bookService.reservConfirm(
          {
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")),
            aPobytId: Number(this.props.reservationId) || 0
          }, {})
        clearInterval(this.interval);
        clearInterval(this.logInterval);
        clearTimeout(this.timeout);
        sendErrorLog("1", "1", `potwierdzenie rezerwacji, czas: ${this.timeDifference()}`)
        store.dispatch(Actions.pageState.addFcmLogMessage(`potwierdzenie rezerwacji, czas: ${this.timeDifference()}`, 2))
        //console.log(res)  
      } catch (error) {
        await sendErrorLog("0", "-1", '/manager/recepcjaPobytPotwierdz')
        await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytPotwierdz", 2))
        console.log(error);
      }

    }
  }

  async sendFailure() {
    try {
      let res: ReservationId = await bookService.reservCancel(
        {
          hotelId: CONFIG.hotelID,
          aOperatorId: Number(sessionStorage.getItem("operator_id")),
          aPobytId: Number(this.props.reservationId) || 0
        }, {})
        clearInterval(this.interval);
        clearInterval(this.logInterval);
        clearTimeout(this.timeout);
        sendErrorLog("1", "1", `anulowanie rezerwacji, czas: ${this.timeDifference()}`)
        store.dispatch(Actions.pageState.addFcmLogMessage(`anulowanie rezerwacji, czas: ${this.timeDifference()}`, 2))
      //console.log(res)    
    } catch (error) {
      await sendErrorLog("0", "-1", '/manager/recepcjaPobytAnuluj')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytAnuluj", 2))
      console.log(error);
    }
  }

  statusOpis = (status: string, t: any): string[] => {
    let opis: string[] = [];

    // p24
    // brak - start
    // 0 - wybrano metodę płatności
    // 1 - płatność wykonana, czekanie na potwierdzenie
    // 2 - sukces

    // mBank
    // 0 - start
    // 1 - wybrano metodę płatności
    // 2 - sukces

    if(CONFIG.ikonaMBank === "1"){ //mBank

      switch (status) {
        case 'PreStart':
          opis[0] = t('Payment has started1');
          opis[1] = t('Details new window1');
          opis[2] = t('Ask open1');
          opis[3] = t( CONFIG.ikonaMBank === "1" ? 'Click link1 mBank' : 'Click link1 P24');
          opis[10] = t('Payment has started2');
          opis[11] = t('Details new window2');
          opis[12] = t('Ask open2');
          opis[13] = t('Click link2');
          break;
        case '0':
          opis[0] = t('Payment has started1');
          opis[1] = t('Details new window1');
          opis[2] = t('Ask open1');
          opis[3] = t( CONFIG.ikonaMBank === "1" ? 'Click link1 mBank' : 'Click link1 P24');
          opis[10] = t('Payment has started2');
          opis[11] = t('Details new window2');
          opis[12] = t('Ask open2');
          opis[13] = t('Click link2');
          break;
        case '1': 
          opis[0] = t('Payment has started');
          opis[1] = t('The customer has not yet made a payment');
          break;  
        case 'PositiveAuthorization': 
          opis[0] = t('The transaction was initially positively authorized by the payment operator');
          opis[1] = t('Its final status will be determined at a later date');
          break;
      }

    } else { //reszta

      switch (status) {
        case 'PreStart':
          opis[0] = t('Payment has started1');
          opis[1] = t('Details new window1');
          opis[2] = t('Ask open1');
          opis[3] = t( CONFIG.ikonaMBank === "1" ? 'Click link1 mBank' : 'Click link1 P24');
          opis[10] = t('Payment has started2');
          opis[11] = t('Details new window2');
          opis[12] = t('Ask open2');
          opis[13] = t('Click link2');
          break;
        case '0':
          opis[0] = t('Payment has started');
          opis[1] = t('The customer has not yet made a payment');
          break;
        case '1':
          opis[0] = t('Payment has started');
          opis[1] = t('Waiting for confirmation from the bank');
          break;  
        case 'PositiveAuthorization':
          opis[0] = t('The transaction was initially positively authorized by the payment operator');
          opis[1] = t('Its final status will be determined at a later date');
          break;
      }

    }


    return opis;
  }

  //PM 2021-08-13 //SW 2021-08-25
  qrCodeValue = () => {
    let value = ''

    value = value + `https://vsc24.net/vscHotelBook/hotel/${CONFIG.hotelID}/${this.props.reservationId ? this.props.reservationId : ''}/${this.props.reservation ? this.props.reservation.gosc_telefon : ''}\n`

    // this.props.dialogContent.forEach((content, index) => {
    //   if (index !== 0)
    //     value = value + content.message + content.messageBoldPrimary + (index === this.props.dialogContent.length ? '' : '\n')
    // })

    //vscTest
    //console.log(value)
    return value
  }

  Icon = (Icon: any, color: string = '#458B00') => {
    return <Icon style={{ fontSize: "25px", marginRight: "10px", float: "left", color: color }} /> 
}

  //PM 2021-08-25
  //qr code tylko jesli PositiveFinish
  render() {
    console.log(this.props)
    console.log(this.state)
    const { t, classes } = this.props;
    const statusOpis = this.statusOpis(this.state.status, t);



    if (this.props.success === true &&
      (this.state.status === 'PreStart' ||
        this.state.status === '0' ||
        this.state.status === '1' ||
        this.state.status === 'PositiveAuthorization' ||
        this.state.status === '2'))
      return (
        <>
          <Dialog
            disableEscapeKeyDown
            disableBackdropClick
            maxWidth="xs"
            open={this.state.open}
            onClose={this.handleModalClose}
            fullWidth
            BackdropProps={{
              open: this.state.openConfirm ? false : true
            }}
          >
            <DialogTitle disableTypography style={{ minWidth: "280px" }}>
              <Typography variant="h6" component="h2" color="primary">
                <b>{(this.state.status === 'PreStart' ||
                  this.state.status === '0' ||
                  this.state.status === '1' ||
                  this.state.status === 'PositiveAuthorization') ?
                  t('Transaction status') : this.props.title}</b>
              </Typography>
              <hr />
            </DialogTitle>
            <DialogContent>
              {this.state.status === '2' ? this.props.dialogContent.map(text => (
                <Fragment key={`${text.message} * ${text.messageBoldPrimary}`}>
                  <DialogContentText color="primary" style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px", fontSize: this.state.width < 600 ? "0.9rem" : "1rem" }}>
                  {text.icon ? this.Icon(text.icon, "#458B00") : null}
                    {text.message}
                    {text.messageBoldPrimary ?
                      <b className={classes.primary}>{text.messageBoldPrimary}</b> : null}
                  </DialogContentText>
                  {/* {this.state.width > 600 ?
                    (
                      <div className={classes.displayNone}>
                        <QRCode
                          id="qrCode"
                          value={this.qrCodeValue()}
                          size={256}
                        />
                      </div>
                    ) : null} */}
                </Fragment>
              )) :
                <Fragment>
                  <DialogContentText>
                    Info <b color="pr"></b>
                  </DialogContentText>
                  <DialogContentText>
                    {statusOpis[10] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[0]}</b> {statusOpis[10]}</p> : wciecie + statusOpis[0]}
                  </DialogContentText>
                  <DialogContentText>
                  {statusOpis[11] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[1]}</b> {statusOpis[11]}</p> : wciecie + statusOpis[1]}
                  </DialogContentText>
                  {statusOpis[2] ? <DialogContentText>
                    {statusOpis[12] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[2]}</b> {statusOpis[12]}</p> : wciecie + statusOpis[2]}
                  </DialogContentText> : null}
                  {statusOpis[3] ? <DialogContentText>
                    {statusOpis[13] ? <p>{wciecie}<Link color='error' href={this.props.paymentLink} target='_blank' ><b>{statusOpis[3]} {statusOpis[13]}</b></Link></p> : wciecie + statusOpis[3]}
                  </DialogContentText> : null}
                </Fragment>}
            </DialogContent>
            <DialogActions>
              {this.props.mode === 1 ?
                <>
                  <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                    onClick={this.handleModalClose}>
                    <b><Trans>Abdon</Trans></b>
                  </Button>
                  <Button variant="contained" color="primary" size="small" style={{ textTransform: "none" }}
                    onClick={this.openConfirm}>
                    <b><Trans>Cancel</Trans></b>
                  </Button>
                </>
                :
                <>
                  {/* {this.state.width > 600 && this.state.status === 'PositiveFinish' ?
                    (
                      <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                        onClick={() => downloadQRReserv(
                          Number(this.props.reservationId), (this.props.reservation ? this.props.reservation.data_od : ''), (this.props.reservation ? this.props.reservation.data_do : ''), (this.props.roomDescription ? this.props.roomDescription : ''), (this.props.reservation ? this.props.reservation.ilosc_osob : '')
                        )}
                      >
                        <b>qr code</b>
                      </Button>
                    ) : null} */}
                  <Button variant="outlined" color="primary" size="small" style={{textTransform: "lowercase"}}
                    onClick={this.handleModalClose}
                    disabled={(this.state.status === 'PreStart' ||
                      this.state.status === '0' ||
                      (this.state.status === '1' && this.props.page.preautoryzacja === 0) ||
                      this.state.status === 'PositiveAuthorization')}>
                    <b><Trans>Back</Trans></b>
                  </Button>
                  {this.state.status === "2" && this.props.page.contact.payWeb !== "5"? 
                  <Button variant="contained" color="primary" size="small"
                    onClick={this.openManageReservation} >
                    <b>OK</b>
                  </Button> : null}
                </>
              }
            </DialogActions>
          </Dialog>
          <Dialog
            disableEscapeKeyDown
            maxWidth="xs"
            open={this.state.openConfirm}
            fullWidth
          >
            <DialogTitle disableTypography>
              <Typography gutterBottom variant="h6" component="h2" color="primary">
                <b><Trans>Choose</Trans></b>
              </Typography>
              <hr style={{ marginTop: "10px" }} />
            </DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.dialogContentText} >
                <span ><Trans>Reserv cancel</Trans></span>
              </DialogContentText>
            </DialogContent >
            <DialogActions >
              <Button onClick={this.closeConfirm} variant="outlined" size="small" color="primary"
                style={{ textTransform: "none" }}
              >
                <b><Trans>Back</Trans></b>
              </Button>
              <Button
                onClick={this.cancellReservation}
                variant="contained" size="small" color="primary" style={{ textTransform: "none" }}
              //disabled={this.state.rez_id.length > 0 ? false : true}
              >
                <b><Trans>Next</Trans></b>
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    else
      return (
        <MuiThemeProvider theme={ selectTheme(this.props.yellow ? "5" : this.props.page.windowTheme) }>
        <Dialog
          disableEscapeKeyDown
          disableBackdropClick
          maxWidth="xs"
          open={this.state.open}
          onClose={this.handleModalClose}
          fullWidth
        >
          <DialogTitle disableTypography style={{ minWidth: "280px" }}>
            <Typography variant="h6" component="h2" color="error">
              <b>{this.props.titleFailure}</b>
            </Typography>
            <hr />
          </DialogTitle>
          <DialogContent>
            {this.props.dialogContentFailure.map((text: any, index: any) => (
              <DialogContentText key={index} /*color="primary"*/ style={{ fontSize: this.state.width < 600 ? "0.9rem" : "1rem", whiteSpace: "pre" }}>
                {text.message}
                {text.messageBoldPrimary ?
                  <Typography component="span" color="secondary" ><b className={classes.pre}>{text.messageBoldPrimary}</b></Typography> : null}
              </DialogContentText>
            ))}
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="secondary" size="small"
              onClick={this.handleModalClose}>
              <b>OK</b>
            </Button>
          </DialogActions>
        </Dialog>
        </MuiThemeProvider>
      );
  }
}

const styles = (theme: Theme) => ({
  redButton: {
    marginTop: theme.spacing(3),
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #f44336, #f44336)",
    border: "1px solid #f44336",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px"
  },
  confirm: {
    marginTop: theme.spacing(3),
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #69b076, #458B00)",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px",
    border: "1px solid rgba(69, 139, 0, 0.5)",
    "&:hover": {
      border: "1px solid rgba(69, 139, 0, 0.5)"
    }
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600
  },
  alert: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#ffffff',
    padding: theme.spacing(2, 4, 3),
    outline: 0
  },
  body: {
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight,
    color: "#555"
  },
  primary: {
    color: theme.palette.primary.main
  },
  error: {
    color: theme.palette.error.main
},
  secondary: {
    color: theme.palette.secondary.main,
    whiteSpace: "pre" as "pre"
  },
  dialogContentText: {
    color: theme.palette.text.secondary,
    whiteSpace: "pre" as "pre",
    //fontSize: "14px"
  },
  displayNone: {
    display: 'none'
  },
  pre: {
    whiteSpace: "pre" as "pre"
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Notifier)));